import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { FiX, FiChevronDown } from "react-icons/fi";
import { BsCreditCard } from "react-icons/bs";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  // Helper to get sale price logic based on ID
  const getProductPrices = (product) => {
    const originalPrice = parseFloat(product.price);
    let salePrice = originalPrice * 0.6; // Default 40% off

    if (product.id === 1) salePrice = 32.4;
    else if (product.id === 6) salePrice = 29.4;
    else if (product.id === 2) salePrice = 26.4;

    return { originalPrice, salePrice };
  };

  const calculateSubtotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const { salePrice } = getProductPrices(product);
        total += salePrice * item.quantity;
      }
    });
    return total;
  };

  const calculateTotalOriginal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const { originalPrice } = getProductPrices(product);
        total += originalPrice * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateSubtotal();
  const totalOriginal = calculateTotalOriginal();
  const totalSaved = totalOriginal - subtotal;

  // Total items count
  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="empty-cart">
          <h2>Your Bag is empty</h2>
          <Link to="/shop" className="btn-continue-shopping" onClick={toTop}>
            Continue Shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-container">
        <div className="cart-left">
          <div className="cart-header">
            <h1>
              Your Bag{" "}
              <span className="item-count">
                ({totalItems} Item{totalItems !== 1 ? "s" : ""})
              </span>
            </h1>
            <p className="subtotal-display">${subtotal.toFixed(2)} Subtotal</p>
          </div>

          <div className="cart-items">
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;

              const { originalPrice, salePrice } = getProductPrices(product);

              return (
                <div className="cart-item" key={`${item.id}-${index}`}>
                  <div className="item-image">
                    <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                      <img src={product.image} alt={product.name} />
                    </Link>
                  </div>

                  <div className="item-details">
                    <div className="item-title-row">
                      <Link
                        to={`/shopDetails/${product.id}`}
                        className="item-name"
                        onClick={toTop}
                      >
                        {product.name}
                      </Link>
                      <div className="item-price-col">
                        <div className="price-details">
                          <span className="sale-price">
                            ${salePrice.toFixed(2)}
                          </span>
                          <span className="original-price strike-through">
                            ${originalPrice.toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <button
                        className="btn-remove"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                        aria-label="Remove item"
                      >
                        <FiX />
                      </button>
                    </div>

                    <div className="item-options">
                      <p>Color: {item.color}</p>
                      <p>
                        Size:{" "}
                        <span className="dropdown-style">{item.size} </span>
                      </p>
                    </div>

                    <div className="item-actions-row">
                      <div className="quantity-selector">
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity - 1
                            )
                          }
                        >
                          -
                        </button>
                        <span className="quantity">{item.quantity}</span>
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity + 1
                            )
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="cart-sidebar">
          <div className="order-summary">
            <h2>Order Summary</h2>

            <div className="summary-row">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span>FREE</span>
            </div>

            <div className="shipping-dropdown">
              <span>Standard Delivery (4-6 Business Days)</span>
            </div>

            <div className="summary-row total-row">
              <span>Estimated Total</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>

            <div className="summary-row savings-row">
              <span className="dropdown-style">
                You save <FiChevronDown />
              </span>
              <span>${totalSaved.toFixed(2)}</span>
            </div>

            <div className="checkout-buttons">
              <button className="btn-guest-checkout" onClick={handleCheckout}>
                Guest Checkout
              </button>
            </div>

            <div className="secure-checkout">
              <BsCreditCard className="card-icon" />
              <span>Secure</span>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
